/*# sourceMappingURL=neck.component-GW63NSUX.css.map */
